import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
     METAVERSE_URL: 'https://map.yells.com.cn/#/homepage'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
